import { useEffect, useState } from 'react'
import { getCustomerInfoLocalStorage } from 'utils/customerInfoLocalStorage'
import useCreateStore from '../../lib/useCreateStore'
import messageFormActions from './actions'
import messageFormSelectors from './selectors'

const initialState = {
  form: {
    name: '',
    email: '',
    subject: '',
    category: '',
    message: '',
    phone: '',
    property_locality: '',
  },
  sendFormLoading: false,
  sendFormError: false,
}

const MessageFormStore = useCreateStore(() => {
  const [$messageForm, setMessageForm] = useState(initialState)

  // Lido após a montagem para o primeiro render bater com o HTML
  // pré-renderizado (react-snap); senão o hydrate mantém atributos
  // desatualizados, como o `disabled` do botão de prosseguir.
  useEffect(() => {
    const { name, email } = getCustomerInfoLocalStorage()
    if (!name && !email) return

    setMessageForm(prev => ({
      ...prev,
      form: {
        ...prev.form,
        name: prev.form.name || name || '',
        email: prev.form.email || email || '',
      },
    }))
  }, [])

  const actions = messageFormActions(setMessageForm)
  const selectors = messageFormSelectors($messageForm)

  return { $messageForm, ...actions, ...selectors }
})

export const useMessageForm = () => MessageFormStore()
export const MessageFormContext = MessageFormStore.Context
export const MessageFormProvider = MessageFormStore.Provider
